import React, { useEffect, useState, useRef } from 'react';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import { WALLET_BALANCE_LOGS_LIST } from '../../../Utils/appConstants';

import { getExportFormat, getUTCToLocalDateTimeFormat, toDayDate, queryDate } from '../../../Utils/function';
import { getRequest } from '../../../Utils/AppApi';
import { getUser, INRFormat } from '../../../Utils/Common';
import { useHistory } from "react-router-dom";
import { DatePicker, Tooltip } from 'antd';

const user = getUser();

function WalletBalanceLogs(props) {
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';

    const [startDate, setStartDate] = useState(toDayDate());
    const [endDate, setEndDate] = useState(toDayDate());
    const [searchUserId, setSearchUserId] = useState('');
    const [searchReferenceId, setSearchReferenceId] = useState('');
    const [searchDescription, setSearchDescription] = useState('');
    const [getData, setData] = useState([]);
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);

    // Columns definition for the table
    const columns = [
        {
            name: 'Date Time',
            cell: row => getUTCToLocalDateTimeFormat(row.createdAt || row.updatedAt),
            sortable: true,
        },
        {
            name: 'TXN ID',
            selector: row => <Tooltip placement="bottom" title={row.referenceId}>{row.referenceId}</Tooltip>,
        },
        {
            name: 'User',
            selector: row => row.userName || row.userId,
            sortable: true,
        },
        {
            name: 'Operation',
            selector: row => row.operation?.toUpperCase(),
            sortable: true,
        },
        {
            name: 'Previous Balance',
            selector: row => INRFormat(row.previousBalance),
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => INRFormat(row.amount),
            sortable: true,
        },
        {
            name: 'New Balance',
            selector: row => INRFormat(row.newBalance),
            sortable: true,
        },
        {
            name: 'Description',
            selector: row => <Tooltip placement="bottom" title={row.description}>{row.description}</Tooltip>,
        },

    ];

    // Helper to convert object to query string
    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        // Apply filters
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        params.searchUserId = searchUserId || "";
        params.searchReferenceId = searchReferenceId || "";
        params.searchDescription = searchDescription || "";

        const queryString = objectToQueryString(params);
        getRequest(`${WALLET_BALANCE_LOGS_LIST}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs);
                    setPage(response.data.page);
                } else {
                    setData([]);
                    setTotalRecord(0);
                    setPage(1);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const getCSVDataList = () => {
        let params = {};
        params.exportsCsv = true;
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        params.searchUserId = searchUserId || "";
        params.searchReferenceId = searchReferenceId || "";
        params.searchDescription = searchDescription || "";

        const queryString = objectToQueryString(params);
        getRequest(`${WALLET_BALANCE_LOGS_LIST}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    let csvdataRecord = [];
                    let csvdata = response.data;
                    csvdata.map((e) => {
                        return csvdataRecord.push({
                            "Date Time": getExportFormat(e.createdAt || e.updatedAt),
                            "User": e.userName || e.userId,
                            "Operation": e.operation?.toUpperCase(),
                            "Amount": e.amount,
                            "Previous Balance": e.previousBalance,
                            "New Balance": e.newBalance,
                            "Previous Operative": e.previousOperativeBalance,
                            "New Operative": e.newOperativeBalance,
                            "Previous Reserve": e.previousReserveBalance,
                            "New Reserve": e.newReserveBalance,
                            "Previous Remaining Payout": e.previousRemainingPayout,
                            "New Remaining Payout": e.newRemainingPayout,
                            "Previous Earning": e.previousEarning,
                            "New Earning": e.newEarning,
                            "Description": e.description,
                            "Reference ID": e.referenceId,
                        });
                    });
                    setCsvData(csvdataRecord);
                    setTimeout(() => {
                        csvLink.current.link.click();
                    }, 1000);
                } else {
                    setCsvData([]);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const handlePageChange = (page, size) => {
        setPage(page);
    };

    const onChangeStartDate = (date, dateString) => {
        setStartDate(date);
    };

    const onChangeEndDate = (date, dateString) => {
        setEndDate(date);
    };

    const handleClear = () => {
        setStartDate("");
        setEndDate("");
        setSearchUserId('');
        setSearchReferenceId('');
        setSearchDescription('');
    };

    const handleSearch = () => {
        getDataReports();
    };

    // Re‑fetch when page changes
    useEffect(() => {
        getDataReports();
    }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

    // Optionally, allow auto‑search on filter changes if needed
    useEffect(() => {
        if (searchUserId || searchReferenceId || searchDescription) {
            handleSearch();
        }
    }, [searchUserId, searchReferenceId, searchDescription]);

    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>Wallet <span className='text-red'>Balance Logs</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className='card col-md-12'>
                            <div className='card-body'>
                                <div className="row">
                                    <div className='col-md-10 date-search mb-0'>
                                        <div className='row'>
                                            <div className='col-md-4 col-lg-4 d-flex'>
                                                <div className="form-group mr-3">
                                                    <label className='date-search-label mb-0 text-blue'>From</label>
                                                    <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={onChangeStartDate} />
                                                </div>
                                                <div className="form-group">
                                                    <label className='date-search-label mb-0 text-red'>To</label>
                                                    <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={onChangeEndDate} />
                                                </div>
                                            </div>
                                            {(user.data.role.code === "A") && (
                                                <div className='col-md-2 col-lg-2'>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'>&nbsp;</label>
                                                        <input type="text" className="form-control form-control-border" placeholder="User ID" onChange={(e) => setSearchUserId(e.target.value)} value={searchUserId} />
                                                    </div>
                                                </div>
                                            )}
                                            <div className='col-md-2 col-lg-2'>
                                                <div className="form-group">
                                                    <label className='date-search-label mb-0 text-red'>&nbsp;</label>
                                                    <input type="text" className="form-control form-control-border" placeholder="Reference ID" onChange={(e) => setSearchReferenceId(e.target.value)} value={searchReferenceId} />
                                                </div>
                                            </div>
                                            <div className='col-md-2 col-lg-2'>
                                                <div className="form-group">
                                                    <label className='date-search-label mb-0 text-red'>&nbsp;</label>
                                                    <input type="text" className="form-control form-control-border" placeholder="Description" onChange={(e) => setSearchDescription(e.target.value)} value={searchDescription} />
                                                </div>
                                            </div>
                                            <div className='col-md-1 col-lg-1'>
                                                <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                                <button type="submit" className="btn btn-primary rounded-pill px-3" onClick={() => handleSearch()}>Search</button>
                                            </div>
                                            <div className='col-md-1 col-lg-1'>
                                                <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                                <button type="button" className="btn btn-default rounded-pill px-4" onClick={() => handleClear()}>Clear</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-2'>
                                        <div className='float-sm-right'>
                                            <button type="button" className="btn btn-primary mr-3" onClick={() => getCSVDataList()} ><i className="fa fa-file-excel"></i> Export</button>
                                            <CSVLink
                                                data={getCsvData}
                                                filename='walletBalanceLogs'
                                                className='hidden'
                                                ref={csvLink}
                                                target='_blank'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="container-fluid pt-2 pb-5">
                                    <DataTable
                                        title={""}
                                        columns={columns}
                                        data={getData.docs}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        paginationTotalRows={getTotalRecord}
                                        onChangeRowsPerPage={getDataReports}
                                        onChangePage={handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WalletBalanceLogs;